import { PaginatedResponse, Redirect } from '@arpeggi/shared'
import { useInfiniteQuery, UseInfiniteQueryOptions } from 'react-query'
import { getNextPage, getPreviousPage } from '../../../__legacy__/queries/common'
import { ApiService, GetManyRedirectsParams } from '../../api'

export const useRedirects = (
  params?: GetManyRedirectsParams,
  options?: UseInfiniteQueryOptions<PaginatedResponse<Redirect>>
) => {
  const { getMany } = ApiService.Redirects.hooks()

  return useInfiniteQuery(
    ['redirects', params],
    ({ pageParam = params?.page || 1 }) => getMany({ ...params, page: pageParam }),
    {
      getPreviousPageParam: (firstPage) => getPreviousPage(firstPage),
      getNextPageParam: (lastPage) => getNextPage(lastPage),
      ...options
    }
  )
}
